import { EBackdropType } from '@enums/nationalAdManagement';

interface IBackdropOption {
  value : EBackdropType;
  label : string;
}

export const backdropTypeOptions: IBackdropOption[] = [
  { value: EBackdropType.Oceanside,     label: 'Oceanside' },
  { value: EBackdropType.MountainView,  label: 'Mountain View' },
  { value: EBackdropType.MidwestFields, label: 'Midwest Fields' },
  { value: EBackdropType.DesertRoad,    label: 'Desert Road' },
  { value: EBackdropType.Cityscape,     label: 'Cityscape' },
];
